import { styled } from 'styled-components';

import CheckSVG from '../assets/aurora-check-icon.svg?react';
import CheckSVGUrl from '../assets/aurora-check-icon.svg?url';

export const AuroraCheckIcon = styled(CheckSVG)<{ $strokeColor?: string }>`
  path {
    stroke: ${({ $strokeColor }) => $strokeColor ?? 'currentColor'};
  }
`;

export const auroraCheckIconUrl = CheckSVGUrl;
